import React, { useState } from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import {
  TvControlledDropdown,
  TvDropdownToggle,
  TvDropdownMenu,
  TvRow,
  TvCol,
  TvDiv,
  TvSpan,
  TvH6,
  TvP,
  TvAnchor,
  TvImg,
  TvI,
  TvBadge,
} from "@trustvid/design-system";
import SimpleBar from "simplebar-react";

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";

//i18n
import { withTranslation } from "react-i18next";

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  return (
    <React.Fragment>
      <TvControlledDropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <TvDropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <TvI className="bx bx-bell bx-tada" />
          <TvBadge color="danger" pill>
            3
          </TvBadge>
        </TvDropdownToggle>

        <TvDropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <TvDiv className="p-3">
            <TvRow className="align-items-center">
              <TvCol>
                <TvH6 className="m-0"> {props.t("Notifications")} </TvH6>
              </TvCol>
              <TvCol className="col-auto">
                <TvAnchor href="#" className="small">
                  {" "}
                  View All
                </TvAnchor>
              </TvCol>
            </TvRow>
          </TvDiv>

          <SimpleBar style={{ height: "230px" }}>
            <Link to="" className="text-reset notification-item">
              <TvDiv className="d-flex">
                <TvDiv className="avatar-xs me-3">
                  <TvSpan className="avatar-title bg-primary rounded-circle font-size-16">
                    <TvI className="bx bx-cart" />
                  </TvSpan>
                </TvDiv>
                <TvDiv className="flex-grow-1">
                  <TvH6 className="mt-0 mb-1">
                    {props.t("Your order is placed")}
                  </TvH6>
                  <TvDiv className="font-size-12 text-muted">
                    <TvP className="mb-1">
                      {props.t(
                        "If several languages coalesce the grammar"
                      )}
                    </TvP>
                    <TvP className="mb-0">
                      <TvI className="mdi mdi-clock-outline" />{" "}
                      {props.t("3 min ago")}{" "}
                    </TvP>
                  </TvDiv>
                </TvDiv>
              </TvDiv>
            </Link>
            <Link to="" className="text-reset notification-item">
              <TvDiv className="d-flex">
                <TvImg
                  src={avatar3}
                  className="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <TvDiv className="flex-grow-1">
                  <TvH6 className="mt-0 mb-1">James Lemire</TvH6>
                  <TvDiv className="font-size-12 text-muted">
                    <TvP className="mb-1">
                      {props.t("It will seem like simplified English") +
                        "."}
                    </TvP>
                    <TvP className="mb-0">
                      <TvI className="mdi mdi-clock-outline" />
                      {props.t("1 hours ago")}{" "}
                    </TvP>
                  </TvDiv>
                </TvDiv>
              </TvDiv>
            </Link>
            <Link to="" className="text-reset notification-item">
              <TvDiv className="d-flex">
                <TvDiv className="avatar-xs me-3">
                  <TvSpan className="avatar-title bg-success rounded-circle font-size-16">
                    <TvI className="bx bx-badge-check" />
                  </TvSpan>
                </TvDiv>
                <TvDiv className="flex-grow-1">
                  <TvH6 className="mt-0 mb-1">
                    {props.t("Your item is shipped")}
                  </TvH6>
                  <TvDiv className="font-size-12 text-muted">
                    <TvP className="mb-1">
                      {props.t(
                        "If several languages coalesce the grammar"
                      )}
                    </TvP>
                    <TvP className="mb-0">
                      <TvI className="mdi mdi-clock-outline" />{" "}
                      {props.t("3 min ago")}
                    </TvP>
                  </TvDiv>
                </TvDiv>
              </TvDiv>
            </Link>

            <Link to="" className="text-reset notification-item">
              <TvDiv className="d-flex">
                <TvImg
                  src={avatar4}
                  className="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <TvDiv className="flex-grow-1">
                  <TvH6 className="mt-0 mb-1">Salena Layfield</TvH6>
                  <TvDiv className="font-size-12 text-muted">
                    <TvP className="mb-1">
                      {props.t(
                        "As a skeptical Cambridge friend of mine occidental"
                      ) + "."}
                    </TvP>
                    <TvP className="mb-0">
                      <TvI className="mdi mdi-clock-outline" />
                      {props.t("1 hours ago")}{" "}
                    </TvP>
                  </TvDiv>
                </TvDiv>
              </TvDiv>
            </Link>
          </SimpleBar>
          <TvDiv className="p-2 border-top d-grid">
            <Link className="btn btn-sm btn-link font-size-14 text-center" to="#">
              <TvI className="mdi mdi-arrow-right-circle me-1"></TvI> <TvSpan key="t-view-more">{props.t("View More..")}</TvSpan>
            </Link>
          </TvDiv>
        </TvDropdownMenu>
      </TvControlledDropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any
};